import { SEO_CONSTANTS } from 'Client/components/ListingPage/services/seo/constant';

export const useSEOLinks = (pageURL: string, hrefLangs: Record<string, string> = {}) => {
    const canonicalLink = {
        rel: SEO_CONSTANTS.canonicalKeyLink,
        href: pageURL,
    };

    const hreflangLinks = Object.keys(hrefLangs).map(lang => ({
        rel: SEO_CONSTANTS.alternateKeyLink,
        hrefLang: lang,
        href: hrefLangs[lang],
    }));

    return [...hreflangLinks, canonicalLink];
};
